// :cow: Cosmose CONFIDENTIAL :iso:
import { JwtHelperService } from '@auth0/angular-jwt';

export const decodeToken = (token: string) => {
  return new JwtHelperService().decodeToken(token);
};
